/**
 * March Agent SDK - TypeScript framework for building AI agents
 *
 * @packageDocumentation
 */

// Main classes
export { MarchAgentApp } from './app.js'
export { Agent, SenderFilter } from './agent.js'
export { Message } from './message.js'
export { Streamer } from './streamer.js'
export { Conversation } from './conversation.js'
export { Memory } from './memory.js'

// Message types
export { ConversationMessage } from './conversation-message.js'

// Structural streaming components
export {
    StructuralStreamer,
    Artifact,
    Surface,
    TextBlock,
    Stepper,
} from './structural/index.js'

// Clients
export { GatewayClient } from './gateway-client.js'
export { ConversationClient } from './conversation-client.js'
export {
    CheckpointClient,
    type CheckpointConfig,
    type CheckpointData,
    type CheckpointMetadata,
    type CheckpointTuple,
} from './checkpoint-client.js'
export { AgentStateClient, type AgentStateResponse } from './agent-state-client.js'
export {
    MemoryClient,
    type MemorySearchOptions,
    type MemoryIngestOptions,
    type IngestResponse,
} from './memory-client.js'
export { AttachmentClient, createAttachmentInfo, type AttachmentInfo } from './attachment-client.js'

// Helpers
export {
    HeartbeatManager,
    type HeartbeatFailureCallback,
    type HeartbeatOptions,
} from './heartbeat.js'

// API Paths Configuration
export {
    AI_INVENTORY_PATHS,
    CONVERSATION_STORE_PATHS,
    MEMORY_PATHS,
    SERVICES,
    type ServiceName,
} from './api-paths.js'

// Types
export type {
    KafkaMessage,
    KafkaHeaders,
    AgentRegistrationData,
    RegisterOptions,
    MessageHandler,
    SenderFilterOptions,
    StreamOptions,
    StreamerOptions,
    AppOptions,
    ConversationData,
    GetMessagesOptions,
    MemoryMessage,
    StoredMemoryMessage,
    MemorySearchResult,
    UserSummary,
    ProduceAck,
    ReconnectionOptions,
    ConnectionState,
    ConnectionStateListener,
} from './types.js'

export { DEFAULT_RECONNECTION_OPTIONS } from './types.js'

// Exceptions
export {
    MarchAgentError,
    RegistrationError,
    KafkaError,
    ConfigurationError,
    APIException,
    HeartbeatError,
    GatewayError,
    ReconnectionError,
} from './exceptions.js'

// Version
export const VERSION = '0.5.1'
